export default __webpack_public_path__ + "static/gold-ce533128a6092a7f0effeafb13a7ed24.jpg";